/**
 * @file 状态管理器
 * @author zhaolongfei
 */

const LISTENERS = Symbol('listeners');
const STATE = Symbol('state');

let _state: Record<string, unknown> = {};

export default class Store {
    private [LISTENERS]: Record<string, Function[]> = {};
    private [STATE]: Record<string, unknown> = {};

    constructor(state: Record<string, unknown> = {}) {
        _state = state;

        for (const prop in _state) {
            if (_state.hasOwnProperty(prop)) {
                this[STATE][prop] = _state[prop];
            }
        }
    }

    get(prop: string) {
        return this[STATE][prop];
    }

    set(prop: string, newValue: unknown) {
        if (!(prop in _state)) {
            throw new Error(`${prop} not exist`);
        }

        const oldValue = this[STATE][prop];

        if (newValue === oldValue) {
            return;
        }

        this[STATE][prop] = newValue;

        this.notify(prop, {
            newValue,
            oldValue,
        });
    }

    watch(prop: string, callback: Function) {
        if (this[LISTENERS][prop]) {
            this[LISTENERS][prop].push(callback);
        }
        else {
            this[LISTENERS][prop] = [callback];
        }
    }

    notify(prop: string, data: Record<string, unknown>) {
        this[LISTENERS]?.[prop]?.forEach(callback => callback(data));
    }

    clear() {
        this[STATE] = {};
        this[LISTENERS] = {};
    }
}
